import { render } from "./SettingsProject.vue?vue&type=template&id=718ce02e"
import script from "./SettingsProject.vue?vue&type=script&lang=js"
export * from "./SettingsProject.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__